/* build/tpl */
import deps from './deps/filterDeep.js';
import getFilterDeep from './getFilterDeep.js';
export default getFilterDeep(deps);
